import { Icon, symbolName } from './Icon'

type ChevronRightIconProps = Readonly<{
  size?: number
  color?: string
}>

export function ChevronRightIcon({
  size = 12,
  color = '#777777',
}: ChevronRightIconProps) {
  return (
    <Icon
      name={symbolName('chevron.right', 'chevron_right')}
      size={size}
      color={color}
    />
  )
}
